// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.button-with-status-container {
  display: flex;
}

.status-on-button {
  position: relative;
  bottom: 10px;
  right: 20px;
}

.action-button-reg {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
}
.action-button-reg:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-reg:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-80 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 80px;
  margin: 0 10px;
}
.action-button-80:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-80:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-100 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 100px;
  margin: 0 10px;
}
.action-button-100:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-100:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-150 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 150px;
  margin: 0 10px;
}
.action-button-150:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-150:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-200 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 200px;
  margin: 0 10px;
}
.action-button-200:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-200:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-delete {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #CB321A;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 250px;
  margin: 0 10px;
}
.action-button-delete:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-delete:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-delete-100 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #CB321A;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 100px;
  margin: 0 10px;
}
.action-button-delete-100:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-delete-100:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-cancel {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #A7A9AC;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
}
.action-button-cancel:active {
  background: blue;
}
.action-button-cancel:hover {
  transform: scale(1.015);
  background: #808080;
}
.action-button-cancel:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-admin {
  border-radius: 3px;
  cursor: pointer;
  border: none;
  background: #0d6efd;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 7px;
  font-weight: 600;
  font-size: 0.85em;
  margin-top: 10px;
  transition: 0.1s ease-in-out;
}
.action-button-admin:hover {
  padding-left: 30px;
}
.action-button-admin:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media only screen and (max-width: 1080px) {
  .action-button-reason {
    font-size: 0.7rem;
    padding: 0px 8px;
  }
}
.action-button-yep {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
}
.action-button-yep:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-yep:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media only screen and (max-width: 1080px) {
  .action-button-reason {
    font-size: 0.7rem;
    padding: 0px 8px;
  }
}
.action-button-inactive-200 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #D1D3D4;
  opacity: 0.7;
  height: 30px;
  transition: 0.1s ease;
  margin: 0 10px;
  width: 200px;
}
.action-button-inactive-200:hover {
  transform: scale(1.015);
  background: #808080;
}
.action-button-inactive-200:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/ActionButton.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACE,aAAA;AAUF;;AARA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AAWF;;AARA;ECTI,kBDUsB;ECWtB,2CAAA;EDTA,eAAA;EACA,YAAA;EACA,mBDWS;ECVT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAWJ;AATI;EACE,uBAAA;EACA,mBDGa;ACQnB;AATI;EACE,YAAA;EACA,mBAAA;AAWN;;AAPA;EC/BI,kBDgCsB;ECXtB,2CAAA;EDaA,eAAA;EACA,YAAA;EACA,mBDXS;ECYT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBDnBa;AC6BnB;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPA;ECpDI,kBDqDsB;EChCtB,2CAAA;EDkCA,eAAA;EACA,YAAA;EACA,mBDhCS;ECiCT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBDxCa;ACkDnB;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPE;ECzEE,kBD0EsB;ECrDtB,2CAAA;EDuDA,eAAA;EACA,YAAA;EACA,mBDrDS;ECsDT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBD7Da;ACuEnB;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPE;EC9FE,kBD+FsB;EC1EtB,2CAAA;ED4EA,eAAA;EACA,YAAA;EACA,mBD1ES;EC2ET,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBDlFa;AC4FnB;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPE;ECnHE,kBDoHsB;EC/FtB,2CAAA;EDiGA,eAAA;EACA,YAAA;EACA,mBDhHE;ECiHF,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBDvGa;ACiHnB;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPE;ECxIE,kBDyIsB;ECpHtB,2CAAA;EDsHA,eAAA;EACA,YAAA;EACA,mBDrIE;ECsIF,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBD5Ha;ACsInB;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPE;EC7JE,kBD8JsB;ECzItB,2CAAA;ED2IA,eAAA;EACA,YAAA;EACA,mBDjJI;ECkJJ,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAUJ;AARI;EACE,gBAAA;AAUN;AARI;EACE,uBAAA;EACA,mBD3JE;ACqKR;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPE;ECpLE,kBDqLsB;EACtB,eAAA;EACA,YAAA;EACA,mBD7Ka;EC8Kb,YAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;AAUJ;AARI;EACE,kBAAA;AAUN;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AALE;EACE;IACE,iBAAA;IACA,gBAAA;EAQJ;AACF;AALE;ECnNE,kBDoNsB;EC/LtB,2CAAA;EDiMA,eAAA;EACA,YAAA;EACA,mBD/LS;ECgMT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAOJ;AALI;EACE,uBAAA;EACA,mBDvMa;AC8MnB;AALI;EACE,YAAA;EACA,mBAAA;AAON;;AAFE;EACE;IACE,iBAAA;IACA,gBAAA;EAKJ;AACF;AAFE;ECjPE,kBDkPsB;EC7NtB,2CAAA;ED+NA,eAAA;EACA,YAAA;EACA,mBDtOI;ECuOJ,YAAA;EACA,YAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;AAIJ;AAFI;EACE,uBAAA;EACA,mBD7OE;ACiPR;AAFI;EACE,YAAA;EACA,mBAAA;AAIN","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n$lt-blue: #7DB7CC;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n$DCSD-logo-green: #84ae30;\n$dashboard-blue: #0d6efd;\n$dk-blue: #0A4064;\n$important: #FEBF31;\n$highlight: #FDF9D0;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$grey5: #333;\n$pale-blue: #C0DEF0;\n$pearl-dk-blue: #0762a7;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$teal-logo: #46A8B0;\n\n$pale-blue-green: #9acdd2;\n$pale-blue-green-outline: #75c2c9;\n\n$pale-purple: #bca0d3;\n$pale-purple-outline: #946eb4;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.button-with-status-container {\n  display: flex\n}\n.status-on-button {\n  position: relative;\n  bottom: 10px;\n  right: 20px\n}\n\n.action-button-reg {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    padding: 0px 20px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n\n.action-button-80 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    width: 80px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n.action-button-100 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    width: 100px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-150 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    width: 150px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-200 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    width: 200px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-delete {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $red;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    width: 250px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-delete-100 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $red;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    width: 100px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-cancel {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $grey2;\n    height: 30px;\n    transition: 0.1s ease;\n    padding: 0px 20px;\n    margin: 0 10px;\n\n    &:active {\n      background: blue;\n    }\n    &:hover {\n      transform: scale(1.015);\n      background: $grey3;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-admin {\n    @include borderRadius(3px);\n    cursor: pointer;\n    border: none;\n    background: $dashboard-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    padding: 0px 7px;\n    font-weight: 600;\n    font-size: .85em;\n    margin-top: 10px;\n    transition: 0.1s ease-in-out;\n\n    &:hover {\n      padding-left: 30px;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n\n\n  @media only screen and (max-width: 1080px) {\n    .action-button-reason {\n      font-size: 0.7rem;\n      padding: 0px 8px;\n    }\n  }\n\n  .action-button-yep {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    padding: 0px 20px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n\n\n  @media only screen and (max-width: 1080px) {\n    .action-button-reason {\n      font-size: 0.7rem;\n      padding: 0px 8px;\n    }\n  }\n\n  .action-button-inactive-200 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $grey1;\n    opacity: .7;\n    height: 30px;\n    transition: 0.1s ease;\n    margin: 0 10px;\n    width: 200px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $grey3;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  \n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
